<template>
<Sidebar v-model:visible="$store.state.calculations.showsidebar" :baseZIndex="1700" :autoZIndex="true" :dismissable="true" position="right" class="p-sidebar-md" :modal="false">

<!--header-->

 <div class="contenttopbar grid px-3 mt-1">
<div class="col-10 md:col-5">
<h3 class="text-primary mb-3 mt-3 font-medium">{{$store.state.calculations.selectednode.title}}</h3>
</div>
<div class="col-2 md:col-7">
<div class="flex align-items-center justify-content-end">


<ConfirmPopup group="deletenode"></ConfirmPopup>
<div class="hide_on_mobile ">
<Button type="button" class="p-button-danger p-button-outlined p-button-sm mt-2" :label="$store.state.languages.lang_phrases.sil" icon="pi pi-trash" @click="deleteNode($event)" />
</div>

<div class="hide_on_mobile ">
<Button type="button" class="p-button-danger p-button-outlined p-button-sm mt-2 ml-2"   @click="severeConnection" >
<span class="material-symbols-outlined md-17 mr-2">
line_start_circle
</span>
Bağlantıyı Kopar

</Button>
</div>

<div class="show_on_mobile">
<Button type="button" class="p-button-danger p-button-outlined p-button-sm mt-2" icon="pi pi-trash" @click="deleteNode($event)" />
</div>

<div class="show_on_mobile">
<Button type="button" class="p-button-danger p-button-outlined p-button-sm mt-2 ml-2" icon="pi pi-trash" @click="severeConnection">
<span class="material-symbols-outlined md-17 mr-2">
line_start_circle
</span>
</Button>
</div>



</div>
</div>

</div>

<!--header-->



<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-else>
<ScrollPanel style="width: 100%; height: 75vh" >


<ProjectNodeData v-if="$store.state.calculations.selectednode.type=='project'" :projects="projects"></ProjectNodeData>

<ProjectsNodeData v-if="$store.state.calculations.selectednode.type=='projects'" :projects="projects"></ProjectsNodeData>

<CustomAttributeDataNode v-if="$store.state.calculations.selectednode.type=='customattribute'" :custom_attributes="custom_attributes"></CustomAttributeDataNode>

<FlowNodeData v-if="$store.state.calculations.selectednode.type=='flow'" :flows="flows"></FlowNodeData>

<FlowsNodeData v-if="$store.state.calculations.selectednode.type=='flows'" :flows="flows"></FlowsNodeData>
<ExemptSuppliersNodeData v-if="$store.state.calculations.selectednode.type=='exempt_suppliers'" :flows="flows"></ExemptSuppliersNodeData>

<OutputNodeData v-if="$store.state.calculations.selectednode.type=='output'" :custom_attributes="custom_attributes"></OutputNodeData>

<SupplierNodeData v-if="$store.state.calculations.selectednode.type=='suppliers'" 
:custom_attributes="custom_attributes"
:flows="flows"
:projects="projects"
:questionlists="questionlists"
></SupplierNodeData>


<CustomAttributeMorphDataNode v-if="$store.state.calculations.selectednode.type=='customattribute_morph'" :custom_attributes="custom_attributes"></CustomAttributeMorphDataNode>

<ConditionalLogicNode v-if="$store.state.calculations.selectednode.type=='conditional_logic'" ></ConditionalLogicNode>


<template v-if="$store.state.calculations.selectednode.key=='calculations'">

<MultiplicationNodeData v-if="$store.state.calculations.selectednode.type=='multiplication'" :key="$store.state.calculations.selectednode.id"></MultiplicationNodeData>
<AdditionNodeData v-if="$store.state.calculations.selectednode.type=='addition'" :key="$store.state.calculations.selectednode.id"></AdditionNodeData>
<SubtractionNodeData v-if="$store.state.calculations.selectednode.type=='subtraction'" :key="$store.state.calculations.selectednode.id"></SubtractionNodeData>
<DivisionNodeData v-if="$store.state.calculations.selectednode.type=='division'" :key="$store.state.calculations.selectednode.id"></DivisionNodeData>


  
</template>
<template v-if="$store.state.calculations.selectednode.key=='outputs'">
<ListNodeData v-if="$store.state.calculations.selectednode.type=='list'" :key="$store.state.calculations.selectednode.id"></ListNodeData>
<GroupNodeData v-if="$store.state.calculations.selectednode.type=='group'" :key="$store.state.calculations.selectednode.id"></GroupNodeData>
</template>


</ScrollPanel>	
</template>

</Sidebar>
</template>

<script>
import ProjectNodeData from "./ProjectNodeData"
import CustomAttributeDataNode from "./CustomAttributeDataNode"
import FlowNodeData from "./FlowNodeData"
import OutputNodeData from "./OutputNodeData"
import SupplierNodeData from "./SupplierNodeData"
import AdditionNodeData from "./AdditionNodeData"
import DivisionNodeData from "./DivisionNodeData"
import MultiplicationNodeData from "./MultiplicationNodeData"
import PercentageNodeData from "./PercentageNodeData"
import SubtractionNodeData from "./SubtractionNodeData"
import ListNodeData from "./ListNodeData"
import GroupNodeData from "./GroupNodeData"
import ProjectsNodeData from "./ProjectsNodeData"
import FlowsNodeData from "./FlowsNodeData"
import ExemptSuppliersNodeData from "./ExemptSuppliersNodeData"
import CustomAttributeMorphDataNode from "./CustomAttributeMorphDataNode"
import ConditionalLogicNode from "./ConditionalLogicNode"

export default {

  name: 'CalculationSidebar',

  data () {
    return {
    	loading:true,
    	projects:[],
    	flows:[],
    	questionlists:[],
    	inputfieldsection:[],
    	inputfields:[],
    	custom_attributes:[],
    	projectperiods:[],
    }
  },
  components:{
  	ProjectNodeData,
  	CustomAttributeDataNode,
  	FlowNodeData,
    OutputNodeData,
    SupplierNodeData,
    AdditionNodeData,
    DivisionNodeData,
    MultiplicationNodeData,
    PercentageNodeData,
    SubtractionNodeData,
    ListNodeData,
    GroupNodeData,
    ProjectsNodeData,
    FlowsNodeData,
    ExemptSuppliersNodeData,
    CustomAttributeMorphDataNode,
    ConditionalLogicNode,
  },
  computed:{
    show_sidebar()
    {
      return this.$store.state.calculations.showsidebar     
    },
  	selectednode_id()
  	{
  		if(this.$store.state.calculations.selectednode)
  		{
  			return this.$store.state.calculations.selectednode.id
  		}  		
  	},
  },
  watch:{
    show_sidebar(newval)
    {
      if(newval && this.selectednode_id)
      {
        this.parseNodeData()
      }
    },
  	selectednode_id(newVal)
  	{
  		if(this.$store.state.calculations.showsidebar)
      {
        console.log("parseNodeData")
        this.parseNodeData()
      }
  		
  	}
  },
  methods:{
  	async parseNodeData()
  	{

  		console.log(this.$store.state.calculations.selectednode.type)
  		this.loading = true
  		if(this.$store.state.calculations.selectednode.type=="project")
      {
        await this.getProjects()
      }
      if(this.$store.state.calculations.selectednode.type=="projects")
      {
        await this.getProjects()
      }
  		if(this.$store.state.calculations.selectednode.type=="flow")
      {
        await this.getFlows()
      }
      if(this.$store.state.calculations.selectednode.type=="flows")
      {
        await this.getFlows()
      }
  		if(this.$store.state.calculations.selectednode.type=="output")
  		{
  			await this.getCustomAttributes()
  		}
  		if(this.$store.state.calculations.selectednode.type=="customattribute")
      {
        await this.getCustomAttributes()
      }

      if(this.$store.state.calculations.selectednode.type=="customattribute_morph")
      {
        await this.getCustomAttributes()
      }
      
      if(this.$store.state.calculations.selectednode.type=="suppliers")
      {
        console.log("getSupplierNodeData")
        await this.getSupplierNodeData()
      }

  		this.loading = false
  	},
    async getSupplierNodeData()
    {
      this.custom_attributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$route.params.id)
      this.projects = await this.generalApiGetWithoutLoader("brand_projects/"+this.$route.params.id)
      this.flows = await this.generalApiGetWithoutLoader("brand/flows/"+this.$route.params.id)
      let questionlists = await this.generalApiGetWithoutLoader("questionlists/brand_questionlists/"+this.$route.params.id)
      for(let questionlist of questionlists)
      {
        questionlist.options = [
        {name:"Soru listesi puanı",type:"questionlist_points",id:questionlist.id},
        {name:"Bölüm",type:"inputfieldsection",id:questionlist.id},
        {name:"Soru",type:"inputfield",id:questionlist.id},
        ]
      }
      this.questionlists = await questionlists
    },
  	async getCustomAttributes()
  	{
  		this.custom_attributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$route.params.id)
  		console.log(this.custom_attributes)
  	},
  	async getProjects()
  	{
  		this.projects = await this.generalApiGetWithoutLoader("brand_projects/"+this.$route.params.id)
  	},
  	async getFlows()
  	{
  		this.flows = await this.generalApiGetWithoutLoader("brand/flows/"+this.$route.params.id)
  	},
  	async getQuestionlists()
  	{
  		this.questionlists = await this.generalApiGetWithoutLoader("questionlists/brand_questionlists/"+this.$route.params.id)
  	},
    severeConnection()
    {

      let nodes = this.$store.state.calculations.nodes
      let connections = this.$store.state.calculations.connections
      let node = this.$store.state.calculations.selectednode
      //let selected_node = this.sanitizeArray(this.$store.state.calculations.selectednode)
      
      //selected_node.inputs = []
      //this.$store.dispatch('calculations/setSelectedNode',selected_node)

      if(node.key=="sources")
      {
        let output_cons = connections.filter((item)=>{return item.from==node.id})
        for(let output_conn of output_cons)
        {
          connections = connections.filter((item)=>{return item.id !== output_conn.id})
          this.$store.dispatch('calculations/setConnections',connections)
        }
        
      }
      else if(node.key=="outputs")
      {
        let input_conns = connections.filter((item)=>{return item.to==node.id})
        for(let input_conn of input_conns)
        {
          connections = connections.filter((item)=>{return item.id !== input_conn.id})
          this.$store.dispatch('calculations/setConnections',connections)
        }
        
      }
      else
      {
        let output_conns = connections.filter((item)=>{return item.from==node.id})
        for(let output_conn of output_conns)
        {
          connections = connections.filter((item)=>{return item.id !== output_conn.id})
        }
        

        let input_conns = connections.filter((item)=>{return item.to==node.id})

        for(let input_conn of input_conns)
        {
          connections = connections.filter((item)=>{return item.id !== input_conn.id})
        }
        this.$store.dispatch('calculations/setConnections',connections)
        
      }
        //nodes = nodes.filter((item)=>{return item.id !== node.id})
        //this.$store.dispatch('calculations/setNodes',nodes)
        this.$store.state.calculations.fromnode = null
      setTimeout(()=>{        
        this.$store.dispatch('calculations/setSidebar',false) 
      },10)

    },

    deleteNode(event)
    {
      this.$confirm.require({
            target: event.currentTarget,
            group: 'deletenode',
            message: this.$store.state.languages.lang_phrases.bu_kaydi_silmek_istiyor_musunuz,
            header: this.$store.state.languages.lang_phrases.silme_uyarisi,
            icon: 'pi pi-exclamation-triangle',
            acceptClass: 'p-button-danger p-button-outlined',
            acceptLabel:this.$store.state.languages.lang_phrases.devam_et,
            rejectLabel:this.$store.state.languages.lang_phrases.iptal,
            accept: async () => {
                //await this.$store.dispatch('ui/setDeletedState',false) 
                this.confirmDeleteNode()
            },
            reject: () => {
                
            }
        });
    },
  	confirmDeleteNode()
  	{
  		let nodes = this.$store.state.calculations.nodes
    	let connections = this.$store.state.calculations.connections
    	let node = this.$store.state.calculations.selectednode

    	if(node.key=="sources")
    	{
    		let output_cons = connections.filter((item)=>{return item.from==node.id})
    		for(let output_conn of output_cons)
    		{
    			connections = connections.filter((item)=>{return item.id !== output_conn.id})
    			this.$store.dispatch('calculations/setConnections',connections)
    		}
    		
    	}
    	else if(node.key=="outputs")
    	{
    		let input_conns = connections.filter((item)=>{return item.to==node.id})
    		for(let input_conn of input_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== input_conn.id})
    			this.$store.dispatch('calculations/setConnections',connections)
    		}
    		
    	}
    	else
    	{
    		let output_conns = connections.filter((item)=>{return item.from==node.id})
    		for(let output_conn of output_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== output_conn.id})
    		}
    		

    		let input_conns = connections.filter((item)=>{return item.to==node.id})

    		for(let input_conn of input_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== input_conn.id})
    		}
    		this.$store.dispatch('calculations/setConnections',connections)
    		
    	}
        nodes = nodes.filter((item)=>{return item.id !== node.id})
        this.$store.dispatch('calculations/setNodes',nodes)
        this.$store.state.calculations.fromnode = null
    	setTimeout(()=>{
    		
    		this.$store.dispatch('calculations/setSidebar',false) 
    	},10)

    	
    },
  },
}
</script>

<style lang="css" scoped>
</style>